import React, { Fragment } from "react";
import { Link } from "react-router";
import { IStandard } from "../../../model/interface/standard";
import Constant from "../../../utils/constant";

interface StandardDetailProps {
  allowMultiSelect: boolean;
  onSourceChange?: (standardId: number) => void;
  onDestinationChange?: (
    e: React.ChangeEvent<HTMLInputElement>,
    standardId: number
  ) => void;
}

function StandardDetail(props: IStandard & StandardDetailProps) {
  const {
    subjectName,
    domainName,
    domainId,
    standardId,
    name,
    code,
    totalQuestions,
    allowMultiSelect,
    onSourceChange,
    onDestinationChange,
  } = props;
  return (
    <Fragment>
      <div
        className={`mt-5 bg-gray-5 sm:pr-6 lg:pr-8 lg:flex-shrink-0 lg:border-l lg:border-gray-200 xl:pr-0  shadow overflow-hidden border border-gray-200 sm:rounded-lg ${
          onSourceChange ? "" : ""
        }`}
      >
        <div className="p-4 flex">
          <div className="flex items-start mr-3">
            {onSourceChange && (
              <input
                id="isActiveSource"
                name="linkDetailSource"
                type={allowMultiSelect ? "checkbox" : "radio"}
                className=" focus:ring-primary-color h-6 w-6 text-primary-color border-gray-300 rounded"
                onChange={
                  standardId ? () => onSourceChange(standardId) : undefined
                }
              />
            )}

            {onDestinationChange && standardId && (
              <input
                id="isActiveDestination"
                name="linkDetailDestination"
                type={allowMultiSelect ? "checkbox" : "radio"}
                className="isActiveDestination focus:ring-primary-color h-6 w-6 text-primary-color border-gray-300 rounded"
                onChange={(e) => onDestinationChange(e, standardId)}
              />
            )}
          </div>
          <div className="w-full">
            <Link
              to={Constant.EDITSTANDARD.replace(
                ":id",
                standardId ? standardId.toString() : ""
              )}
              className="text-xs block mb-1"
            >
              <span className="px-1 inline-block">
                {standardId} {code} {name}
              </span>
              <span className="float-right text-gray-700 font-semibold">
                {totalQuestions && totalQuestions > 0 ? totalQuestions : 0}{" "}
                Questions
              </span>
            </Link>
            <Link
              to={Constant.EDITDOMAIN.replace(
                ":id",
                domainId ? domainId.toString() : ""
              )}
              className="block"
            >
              <p className="text-xs text-gray-600">{domainName}</p>
            </Link>

            <h3 className="cursor-pointer mt-1"> {subjectName}</h3>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default StandardDetail;
